var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.767,
    height: 8.764,
    viewBox: "0 0 8.767 8.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Up_Arrow_-_Small",
    "data-name": "Up Arrow - Small",
    d: "M4.106,1.789a1,1,0,0,1,1.789,0L9.276,8.553A1,1,0,0,1,8.382,10H1.618A1,1,0,0,1,.724,8.553Z",
    transform: "translate(-0.617 -1.236)",
    fill: "#5fad56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallUpArrow);
export default __webpack_public_path__ + "static/media/small-up-arrow.b79eaa11079d8f64a74edfe8d521135b.svg";
export { ForwardRef as ReactComponent };